"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _stylingUtils = require("../../services/stylingUtils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

var Tabs =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Tabs, _React$Component);

  function Tabs(props) {
    var _this;

    _classCallCheck(this, Tabs);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Tabs).call(this, props));
    _this.state = {
      activeTab: _this.props.children[0].props.label,
      tabContentId: Math.floor(10000 + Math.random() * 90000)
    };
    _this._handleKeyDown = _this._handleKeyDown.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    return _this;
  }

  _createClass(Tabs, [{
    key: "_getClassNames",
    value: function _getClassNames() {
      return (0, _stylingUtils.getClassNames)(this.props.className, {
        "rhe-tabs-container": true
      });
    }
  }, {
    key: "_changeTab",
    value: function _changeTab(label) {
      this.setState({
        activeTab: label
      });
    }
  }, {
    key: "_handleKeyDown",
    value: function _handleKeyDown(e, label) {
      if (e.key === " " || e.key === "Spacebar") {
        e.preventDefault();
      }

      if (e.key === "Enter" || e.key === " " || e.key === "Spacebar") {
        this._changeTab(label);

        document.getElementById("tab-content-".concat(this.state.tabContentId)).focus();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var children = this.props.children;
      return _react.default.createElement("div", {
        className: this._getClassNames()
      }, _react.default.createElement("ul", {
        className: "tabs"
      }, this.props.children.map(function (tab, i) {
        var tabId = tab.props.label.toLowerCase().replace(" ", "-");
        return _react.default.createElement("li", {
          key: i,
          id: tabId,
          className: "".concat(tab.props.label === _this2.state.activeTab && 'active', " ").concat(tab.props.count && 'hasCount'),
          "aria-label": tab.props.label,
          tabIndex: "0",
          role: "button",
          onKeyDown: function onKeyDown(e) {
            return _this2._handleKeyDown(e, tab.props.label);
          },
          onClick: function onClick() {
            _this2._changeTab(tab.props.label);

            if (tab.props.onClick) {
              tab.props.onClick();
            }
          }
        }, tab.props.count && _react.default.createElement("span", {
          className: "count"
        }, tab.props.count), tab.props.label);
      })), _react.default.createElement("div", {
        id: "tab-content-".concat(this.state.tabContentId),
        className: "tab-content",
        tabIndex: "0"
      }, _react.default.Children.map(children, function (tab) {
        return _react.default.cloneElement(tab, _objectSpread({}, tab.props, {
          show: tab.props.label === _this2.state.activeTab
        }));
      })));
    }
  }]);

  return Tabs;
}(_react.default.Component);

exports.default = Tabs;
Tabs.propTypes = {
  className: _propTypes.default.string
};